import { HardwareItemFilter } from './hardwareTypes';
import { useReducer, useState } from 'react';
import HardwareTable from './HardwareTable';
import HardwareFilterBar from './HardwareFilterBar';
import HardwareOptionsBar from './HardwareOptionsBar';
import { Item } from '../../utils/sharedTypes';
import { FormControlLabel, Grid, Switch } from '@mui/material';

const initialFilters: HardwareItemFilter = {
  hardwareType: null,
  company: null,
  serial: '',
  soldDateFrom: '',
  soldDateTo: '',
  warrantyActive: '',
};

const Hardware = () => {
  const [filters, setFilters] = useReducer(
    (curVals: HardwareItemFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedHardware, setSelectedHardware] = useState<Item[]>([]);
  const [lptSold, setLptSold] = useState<boolean>(true);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <>
      <HardwareFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container spacing={1}>
        <Grid item>
          <HardwareOptionsBar
            selectedHardware={selectedHardware}
            setSelectedHardware={setSelectedHardware}
            editModalOpenFlag={editModalOpenFlag}
            setEditModalOpenFlag={setEditModalOpenFlag}
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                checked={lptSold}
                onChange={() => {
                  setLptSold((value) => !value);
                }}
                color='primary'
              />
            }
            label='Limit to LPT Sold Hardware'
          />
        </Grid>
      </Grid>
      <HardwareTable
        setSelectedHardware={setSelectedHardware}
        filters={filters}
        lptSold={lptSold}
        setEditModalOpenFlag={setEditModalOpenFlag}
      />
    </>
  );
};

export default Hardware;
